export class Product {

  id: number;
  clientId: number;
  categoryId: number;
  name: string;
  description: string;
  stock: number;
  imageUrl: string
  value: number;
  subtotal: number;
  selected: boolean;

	constructor( p ?: any) {
		this.id           = p ? p.id : null;
    this.clientId     = p ? p.client_id : null;
    this.categoryId   = p ? p.category_id : null;
    this.name         = p ? p.name : null;
    this.description  = p ? p.description : null;
    this.stock        = p ? p.stock : null;
    this.imageUrl     = p ? p.image_url : null;
    this.value        = p ? p.value : null;
    this.subtotal     = p ? p.value : null;
    this.selected     = false;
  }
  
  mapProduct(list: any[]): Product[] {
    let newList: Product[] = [];
    list.forEach((item: any) => {
      let newItem: Product = new Product(item);
      newList.push(newItem);
    });
    return newList;
  }

}
